import { Compass } from '@watersport/ui-react-icons'
import React from 'react'

interface NotFoundLocationProps {
  searchLocation?: string
}

const NotFoundLocation: React.FC<NotFoundLocationProps> = ({ searchLocation }) => (
  <div className="flex flex-1 flex-col items-center justify-center space-y-5">
    <Compass width={54} height={54} className="text-blue-300" />
    <div className="text-sm text-gray-500 text-center font-medium leading-6 tracking-wider">
      <p>{`No results matching${searchLocation && ':'}`}</p>
      {searchLocation && <p className="text-base-black">{`“${searchLocation}...”`}</p>}
    </div>
  </div>
)

export default NotFoundLocation
